import React from 'react';
import classnames from 'classnames';
import ArtStageArrowL from '@wix/da-ds/pkg/Icons/ArtStageArrowL';
import ArtStageArrowR from '@wix/da-ds/pkg/Icons/ArtStageArrowR';
import BackToStreamButton from '../BackToStreamButton';
import { DuperbrowsePaddle } from './DuperbrowsePaddle';
import { useDuperbrowseKeyboardNavigation } from '../hooks/useDuperbrowseKeyboardNavigation';
import s from './DuperbrowsePaddles.scss';
const DuperbrowsePaddles = ({ className , paddleClassName , iconClassName , enableKeyboardNavigation , navigation: { nextItem , prevItem  } , showBackTo =true , moveNext , movePrev  })=>{
    useDuperbrowseKeyboardNavigation(enableKeyboardNavigation);
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], className)
    }, /*#__PURE__*/ React.createElement(DuperbrowsePaddle, {
        isEnabled: !!prevItem,
        className: classnames(s['prev'], paddleClassName),
        onClick: movePrev,
        dataHook: "arrowL"
    }, /*#__PURE__*/ React.createElement(ArtStageArrowL, {
        customSizable: true,
        disableDefaultColors: true,
        className: classnames(s['icon'], iconClassName)
    })), showBackTo && /*#__PURE__*/ React.createElement(BackToStreamButton, null), /*#__PURE__*/ React.createElement(DuperbrowsePaddle, {
        isEnabled: !!nextItem,
        className: classnames(s['next'], paddleClassName),
        onClick: moveNext,
        dataHook: "arrowR"
    }, /*#__PURE__*/ React.createElement(ArtStageArrowR, {
        customSizable: true,
        disableDefaultColors: true,
        className: classnames(s['icon'], iconClassName)
    })));
};
export default DuperbrowsePaddles;
